import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  form{
    width: 100%;
  }
`;

export const Content = styled.div`
  background: #fff;
  padding: 32px;
  border-radius: 4px;
  margin-bottom: 20px;
`;
